import {
  BulkMessagePermissionSet,
  FarePassPermissionSet,
  PermissionSetType,
  SidebarProductVisibilityPermissionSet,
  UserOwnPermissionSet,
  VehiclePermissionSet,
} from '../sets'
import { AnnouncementPermissionSet } from '../sets/AnnouncementPermissions'
import { DriverUserPermissionSet } from '../sets/DriverUserPermissions'
import { DutyDelayPermissionSet } from '../sets/DutyDelayPermissions'
import { FavoriteLocationPermissionSet } from '../sets/FavoriteLocationPermissions'
import { GroupPermissionSet } from '../sets/GroupPermissions'
import { NotificationSettingPermissionSet } from '../sets/NotificationSettingPermissions'
import { PromoPermissionSet } from '../sets/PromoPermissions'
import { RequestPermissionSet } from '../sets/RequestPermissions'
import { RiderUserPermissionSet } from '../sets/RiderUserPermissions'
import { TripGroupPermissionSet } from '../sets/TripGroupPermissions'
import { UserBanPermissionSet } from '../sets/UserBanPermissions'
import { BookingAgentRole } from './BookingAgentRole'
import { SchedulerRole } from './SchedulerRole'

/**
 * Ensure that at the root level of the role, we only add permission sets to it and not
 * individual permissions. Individual permissions at this level will not get assigned to the role.
 * If individual permissions are required, create a permission set of one permission and add to the role.
 */
export const OperationsManagerRole: PermissionSetType[] = [
  ...BookingAgentRole,
  ...SchedulerRole,
  SidebarProductVisibilityPermissionSet.ShowOperationsProduct,

  RiderUserPermissionSet.Import,
  RiderUserPermissionSet.Export,
  UserOwnPermissionSet.Rider, // Admins should be able to check if they are also a rider.

  DriverUserPermissionSet.Import,
  DriverUserPermissionSet.Export,
  UserOwnPermissionSet.Driver, // Admins should be able to check if they are a also a driver.

  GroupPermissionSet.Write,
  GroupPermissionSet.ImportMembership,
  GroupPermissionSet.ExportMembership,

  DutyDelayPermissionSet.View,

  RequestPermissionSet.ExportRequestRecurrences,
  RequestPermissionSet.Rematch,
  RequestPermissionSet.ManualIntervention,
  RequestPermissionSet.EstimateWithOverrides,
  RequestPermissionSet.WriteRestricted,

  FavoriteLocationPermissionSet.Import,

  AnnouncementPermissionSet.Write,

  UserBanPermissionSet.Write,

  PromoPermissionSet.Export,

  NotificationSettingPermissionSet.View,

  BulkMessagePermissionSet.View,
  BulkMessagePermissionSet.Write,

  FarePassPermissionSet.EditAllocation,

  VehiclePermissionSet.ManageInspection,
  VehiclePermissionSet.ViewInspection,

  TripGroupPermissionSet.View,
  TripGroupPermissionSet.Write,
  TripGroupPermissionSet.Delete,
]
